module.exports = __webpack_public_path__ + "media/images/golf-background-04177cecd54bd5be4114a209635ce0da.png";